import React from 'react';
import { SummaryChart } from '../../SummaryChart/SummaryChart';

import { SummaryCharts } from '../../SummaryStyles';
import { useSelector } from 'react-redux';
import { summarySelector } from '../../../MoneyGuidProSelectors';
import { TabAccordion } from './TabAccordion';

export const TabContent: React.FC<{
  selectedIndex: number;
}> = ({ selectedIndex }) => {
  const data = useSelector(summarySelector);

  if (!data) {
    return null;
  }

  return (
    <>
      <SummaryCharts>
        <SummaryChart data={data.chartsData[selectedIndex]} />
      </SummaryCharts>
      {data.summaryCategories.map(({ description, topics }) => (
        <TabAccordion
          key={description}
          selectedIndex={selectedIndex}
          description={description}
          topics={topics}
        />
      ))}
    </>
  );
};
